import React from "react";

import MainPageLayout from "../layouts/MainPageLayout";


const LawStudies = () => {
  return (
    <>
      <MainPageLayout
        pageEndpoint={
          "pages?filters[slug][$eq]=law-studies"
        }
      />
    </>
  );
};

export default LawStudies;
